import * as React from 'react';
const SvgSmartphoneGen2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M17.67 3.64c-.29-.56-.75-1.02-1.31-1.31C15.72 2 14.88 2 13.2 2h-2.4c-1.68 0-2.52 0-3.16.33-.56.29-1.02.75-1.31 1.31C6 4.28 6 5.12 6 6.8v10.4c0 1.68 0 2.52.33 3.16.29.56.75 1.02 1.31 1.31.64.33 1.48.33 3.16.33h2.4c1.68 0 2.52 0 3.16-.33.56-.29 1.02-.75 1.31-1.31.33-.64.33-1.48.33-3.16V6.8c0-1.68 0-2.52-.33-3.16M12 21c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m4-5.8c0 1 0 2.04-.11 2.25-.1.19-.25.34-.44.44-.21.11-1.25.11-2.25.11h-2.4c-1 0-2.04 0-2.25-.11-.19-.1-.34-.25-.44-.44C8 17.24 8 16.2 8 15.2V7.8c0-1 0-2.04.11-2.25.1-.19.25-.34.44-.44C8.76 5 9.8 5 10.8 5h2.4c1 0 2.04 0 2.25.11.19.1.34.25.44.44.11.21.11 1.25.11 2.25z"
    />
  </svg>
);
export default SvgSmartphoneGen2;
